import { ExpectedEffectiveValues } from '@hkm/shared/effectiveValues/expectedEffectiveValues';

export const TaskManagementEffectiveValues: ExpectedEffectiveValues = new Map().set(
  'enableTaskManagementMobileApplication',
  true
);



// WEBPACK FOOTER //
// ./src/components/TaskManagement/shared/config/taskManagementEffectiveValues.ts